import React from 'react';
import '../styles/footer.css'; 
//exports the footer for every page
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          &copy; 2024 <strong>DevHive</strong> | All Rights Reserved | Powered by <strong>React</strong>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
